import styled from 'styled-components'

export default styled.div`
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  justify-content: space-between;
  margin-top: -5px;
`
